/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { postApiUsercacheV1 } from '../fn/user-cache/post-api-usercache-v-1';
import { PostApiUsercacheV1$Params } from '../fn/user-cache/post-api-usercache-v-1';
import { postApiUsercacheV1Targetuserid } from '../fn/user-cache/post-api-usercache-v-1-targetuserid';
import { PostApiUsercacheV1Targetuserid$Params } from '../fn/user-cache/post-api-usercache-v-1-targetuserid';

@Injectable({ providedIn: 'root' })
export class UserCacheService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiUsercacheV1Targetuserid()` */
  static readonly PostApiUsercacheV1TargetuseridPath = '/private/v1/users-cache/{targetUserId}';

  /**
   * Refresh user cache by id.
   *
   * Refresh user cache by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiUsercacheV1Targetuserid()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiUsercacheV1Targetuserid$Response(params: PostApiUsercacheV1Targetuserid$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiUsercacheV1Targetuserid(this.http, this.rootUrl, params, context);
  }

  /**
   * Refresh user cache by id.
   *
   * Refresh user cache by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiUsercacheV1Targetuserid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiUsercacheV1Targetuserid(params: PostApiUsercacheV1Targetuserid$Params, context?: HttpContext): Observable<void> {
    return this.postApiUsercacheV1Targetuserid$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiUsercacheV1()` */
  static readonly PostApiUsercacheV1Path = '/private/v1/users-cache';

  /**
   * Refresh all users cache.
   *
   * Refresh all users cache
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiUsercacheV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiUsercacheV1$Response(params?: PostApiUsercacheV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiUsercacheV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Refresh all users cache.
   *
   * Refresh all users cache
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiUsercacheV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiUsercacheV1(params?: PostApiUsercacheV1$Params, context?: HttpContext): Observable<void> {
    return this.postApiUsercacheV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
